module.exports = __webpack_public_path__ + "static/img/i147.f4f3516e.png";